/**
 * Цвета заливки ячеек.
 *
 * Заливка — это фон под чужим текстом, а не плашка со своей подписью,
 * поэтому палитра здесь бледная. Насыщенные цвета из `PALETTE` (ими
 * красят статусы и метки) в ячейке съедают текст: чёрное на #ef4444
 * читается плохо, а белым грид ячейки не подписывает.
 *
 * Оттенки — из той самой палитры Google-таблицы, в которой велась работа
 * до этой системы: рекрутёры красили ими ячейки годами, и «жёлтая строка»
 * у всех означает одно и то же. Отсюда же взяты цвета гражданства
 * по умолчанию (#d9ead3 и #cfe2f3).
 *
 * Кому нужен цвет вне набора — рядом в меню стоит системная палитра,
 * а сам набор правится в «Настройки → Оформление».
 *
 * Подписи не декоративные. В рабочей таблице цвет заменял слово: бледные
 * оттенки различали водителей, ярко-жёлтый значил «водителя нет»,
 * бирюзовый в колонке ФИО — «эти двое едут вместе», красный — «отказ».
 * Подпись переносит это знание в систему: иначе оно остаётся в голове
 * у того, кто красил, и первый же новый человек начнёт красить иначе.
 */
export interface FillColor {
  hex: string;
  /** Подпись для всплывающей подсказки и экранного диктора */
  label: string;
}

export const FILL_COLORS: readonly FillColor[] = [
  // Бледные — ими в таблице различали водителей
  { hex: '#f4cccc', label: 'розовая' },
  { hex: '#fce5cd', label: 'персиковая' },
  { hex: '#fff2cc', label: 'жёлтая бледная' },
  { hex: '#d9ead3', label: 'зелёная' },
  { hex: '#d4edbc', label: 'салатовая' },
  { hex: '#d0e0e3', label: 'бирюзовая бледная' },
  { hex: '#cfe2f3', label: 'голубая' },
  { hex: '#c9daf8', label: 'васильковая' },
  { hex: '#d9d2e9', label: 'сиреневая' },
  { hex: '#ead1dc', label: 'лиловая' },
  { hex: '#efefef', label: 'серая' },
  // Яркие — в таблице ими помечали не человека, а положение дел
  { hex: '#ffff00', label: 'жёлтая — водителя нет' },
  { hex: '#00ffff', label: 'бирюзовая — едут вместе' },
  { hex: '#ff0000', label: 'красная — отказ' },
];
